const CONNECTIVITY_IMG =
  'https://d3h1y9jvvpl9bt.cloudfront.net/assets/images/6de993b4-1765-45d3-a333-4d2d20f852f4/clean-shot-2026-01-23-at-14-36-07-2-x-1920w.webp';

const AMENITY_SECTIONS = [
  {
    icon: '🏠',
    title: 'Prime Location',
    items: [
      'Address: Bayshore Road, District 16',
      'A serene coastal enclave with excellent urban access',
      'Cycling paths and pedestrian links to East Coast Park',
      'Future amenities at Bayshore Drive (shops, eateries, sports)',
    ],
  },
  {
    icon: '🚆',
    title: 'Connectivity',
    items: [
      'Bayshore MRT (Thomson-East Coast Line) — less than 1-min walk',
      '10 mins to the CBD via ECP',
      '15 mins to Changi Airport via ECP',
      '20 mins to Orchard via TEL',
    ],
  },
  {
    icon: '🏖️',
    title: 'Amenities & Lifestyle',
    items: [
      'East Coast Park (15km beachfront) — 5–10 min walk',
      'Parkway Parade, i12 Katong, Bedok Mall nearby',
      'Siglap/Katong dining (laksa, seafood)',
    ],
  },
  {
    icon: '📚',
    title: 'Top Schools (1–2km)',
    items: [
      'Temasek Primary School',
      'Bedok Green Primary School',
      'Opera Estate Primary',
      'Victoria School (Secondary)',
      'Temasek Junior College',
    ],
  },
];

export default function LocationMap() {
  return (
    <section id="location-map" className="py-12 md:py-20 bg-[#F8F8F5]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-6 md:mb-8">
          <h4 id="location-map-title">
            <a href="#location-map" className="text-2xl md:text-3xl font-bold text-[#172C37]" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
              Location Map
            </a>
          </h4>
          <p className="text-[#172C37]/60 mt-1 text-sm">Discover amenities near this project</p>
        </div>

        {/* Google Maps Embed */}
        <div className="w-full h-60 sm:h-80 md:h-[420px] rounded-2xl overflow-hidden mb-8 md:mb-10">
          <iframe
            title="Vela Bay Bayshore Road Location Map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7977.5401635231165!2d103.940396!3d1.313411!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da22c6de37bc55%3A0x749baac9476b048b!2sBayshore%20Rd!5e0!3m2!1sen!2ssg!4v1739876138838!5m2!1sen!2ssg"
            width="100%"
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full border-0"
          />
        </div>

        {/* Amenities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-10">
          {AMENITY_SECTIONS.map((section) => (
            <div key={section.title} className="bg-white rounded-2xl p-5 border border-[#172C37]/8">
              <div className="text-2xl mb-3">{section.icon}</div>
              <h3 className="text-base font-bold text-[#172C37] mb-3">{section.title}</h3>
              <ul className="space-y-1.5">
                {section.items.map((item, i) => (
                  <li key={i} className="text-sm text-[#172C37]/70 leading-snug flex items-start gap-1.5">
                    <span className="text-[#172C37]/40 mt-0.5 flex-shrink-0">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Connectivity Image */}
        <div className="w-full rounded-2xl overflow-hidden">
          <img
            src={CONNECTIVITY_IMG}
            alt="Vela Bay Connectivity Map MRT TEL Bayshore"
            className="w-full h-auto object-cover object-top"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
